package xim.poc.game.configuration.v0.behaviors

import xim.poc.game.ActorState
import xim.poc.game.StatusEffect
import xim.poc.game.configuration.SkillApplier
import xim.poc.game.configuration.SkillRangeInfo
import xim.poc.game.configuration.constants.SkillId
import xim.poc.game.configuration.constants.mskillImpenetrableCarapace_2701
import xim.poc.game.configuration.constants.mskill_2699
import xim.poc.game.configuration.constants.mskill_2700
import xim.poc.game.configuration.v0.V0MobSkillDefinitions.basicPhysicalDamage
import xim.poc.game.configuration.v0.V0SpellDefinitions.applyBasicBuff
import xim.resource.AoeType
import kotlin.time.Duration
import kotlin.time.Duration.Companion.seconds

class MobDreadPincerController(actorState: ActorState): V0MonsterController(actorState) {

    override fun getSkillCastTimeOverride(skill: SkillId?): Duration? {
        return if (skill == mskill_2699 || skill == mskill_2700) {
            return 1.5.seconds
        } else {
            super.getSkillCastTimeOverride(skill)
        }
    }

    override fun getSkillRangeOverride(skill: SkillId): SkillRangeInfo? {
        return if (skill == mskill_2700) {
            SkillRangeInfo(4f, 4f, AoeType.Source)
        } else {
            super.getSkillRangeOverride(skill)
        }
    }

    override fun getSkillApplierOverride(skillId: SkillId): SkillApplier? {
        return if (skillId == mskill_2699 || skillId == mskill_2700) {
            SkillApplier(targetEvaluator = basicPhysicalDamage { 1.8f })
        } else if (skillId == mskillImpenetrableCarapace_2701) {
             SkillApplier(targetEvaluator = applyBasicBuff(statusEffect = StatusEffect.ShiningRuby, duration = 60.seconds) { it.status.potency = 75 })
        } else {
            super.getSkillApplierOverride(skillId)
        }
    }

}